import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";
import Reveal from "reveal.js/dist/reveal.js";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    Reveal.on("ready", () => this.refreshSlide());
    Reveal.on("slidechanged", () => this.refreshSlide());

    this.colors = {
      background: null,
      category: null,
      title: null
    };

    // Add keydown event listener for toggling the customizer
    document.addEventListener(
      "keydown",
      this.toggleCustomizerVisibility.bind(this)
    );

    // Initialize customizer visibility
    this.isCustomizerVisible = true;
  }

  toggleCustomizerVisibility(event) {
    // Check if the pressed key is "c"
    if (event.key === "c") {
      this.isCustomizerVisible = !this.isCustomizerVisible;
      const customizer = document.querySelector(".reveal-customizer");
      if (customizer) {
        customizer.style.display = this.isCustomizerVisible ? "block" : "none";
      }
    }
  }

  refreshSlide(e) {
    if (e && e.type === "ajax:success") {
      const form = e.detail[2].response;
      this.element.innerHTML = form;
      return;
    }

    if (!this.currentSlideId) return;

    this.currentSlideForm.then(form => {
      if (!form) return;

      this.element.innerHTML = form;
    });
  }

  changeColor(e) {
    Rails.fire(this.formTarget, "submit");

    const colorComponentEl = e.target.closest(".admin-form-color");
    const colorComponent = this.colorComponent(colorComponentEl);
    const { currentColor, key } = colorComponent;

    switch (key) {
      case "title_color":
        if (this.currentSlideTitleEl) this.currentSlideTitleEl.style.color = currentColor.hex;
        break;
      case "category_color":
        if (this.currentSlideCategoryEl) this.currentSlideCategoryEl.style.color = currentColor.hex;
        this.currentSlideVideoPlayers.forEach(v =>
          v.style.setProperty("--video-player", currentColor.hex)
        );
        break;
      case "background_color":
        if (this.currentSlideBackgroundEl) this.currentSlideBackgroundEl.style.backgroundColor = currentColor.hex;
        break;
      default:
    }
  }

  get currentSlideId() {
    return this.reveal.currentSlide.getAttribute("data-id");
  }

  get currentSlideTitleEl() {
    return this.reveal.currentSlide.querySelector(
      ".reveal-slide-title, .reveal-full-slide-title, .reveal-intro-slide-title, .reveal-gallery-slide-title"
    );
  }

  get currentSlideCategoryEl() {
    return this.reveal.currentSlide.querySelector(
      ".reveal-slide-category, .reveal-breadcrumbs, .reveal-full-slide-date, .reveal-intro-slide-category"
    );
  }

  get currentSlideVideoPlayers() {
    return this.reveal.currentSlide.querySelectorAll(".reveal-video");
  }

  get currentSlideBackgroundEl() {
    return this.reveal.currentBackground;
  }

  get currentSlideForm() {
    const url = `/admin/presentation_slides/${this.currentSlideId}/customizer`;

    const headers = new Headers({
      "X-Requested-With": "XMLHttpRequest"
    });

    const request = new Request(url, {
      headers
    });

    return fetch(request)
      .then(response => {
        if (response.ok) {
          return response.text();
        }

        throw new Error("Not Found");
      })
      .catch(error => console.error("Error:", error));
  }

  get currentSlideData() {
    const url = `/admin/presentation_slides/${this.currentSlideId}.json`;

    const headers = new Headers({
      "X-Requested-With": "XMLHttpRequest"
    });

    const request = new Request(url, {
      headers
    });

    return fetch(request)
      .then(response => {
        if (response.ok) {
          return response.json();
        }

        throw new Error("Not Found");
      })
      .catch(error => console.error("Error:", error));
  }

  colorComponent(el) {
    return this.application.getControllerForElementAndIdentifier(
      el,
      "admin-form-color"
    );
  }

  get reveal() {
    return this.application.getControllerForElementAndIdentifier(
      document.querySelector(".reveal"),
      "reveal"
    );
  }
}
